var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService, ScreenService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable, fromEvent } from 'rxjs';
import { takeWhile, debounceTime, map, distinctUntilChanged, startWith, tap } from 'rxjs/operators';
import * as fromStore from '../../../store';
import * as moment from 'moment';
import { INDRACalendarPriceService } from '@ibe.services/calendar-price.indra.service';
import { TRIP_TYPE_ONE_WAY_CODE, TRIP_TYPE_ROUND_TRIP_CODE, } from '@ibe.config';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAPassengerTypeService } from '@ibe.services/passenger-type.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
var INDRASelectMonthModalComponent = /** @class */ (function (_super) {
    __extends(INDRASelectMonthModalComponent, _super);
    function INDRASelectMonthModalComponent(modalService, screen, store, cdr, calendarPriceService, currencyService, passengerTypeService, ibeAdminService) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.screen = screen;
        _this.store = store;
        _this.cdr = cdr;
        _this.calendarPriceService = calendarPriceService;
        _this.currencyService = currencyService;
        _this.passengerTypeService = passengerTypeService;
        _this.ibeAdminService = ibeAdminService;
        _this.isAlive = true;
        _this.isLoading = true;
        _this.months = [];
        _this.loading$ = _this.store.select(fromStore.getUserLoading);
        _this.isMobile$ = _this.store.select(fromStore.isScreenMobile);
        _this.isMobile = false;
        _this.priceUnit$ = _this.store.select(fromStore.getOptionsBarPriceUnit);
        _this.booking_trip$ = _this.store.select(fromStore.getSelectedBookedTrip);
        _this.dailyCosts$ = _this.store.select(fromStore.getBookingStepsCostsPerDay);
        _this.bookingSteps$ = _this.store.select(fromStore.getSelectedBookingSteps);
        _this.currentStep$ = _this.store.select(fromStore.getSelectedBookingCurrentStep);
        _this.currentStep = 0;
        _this.userInfo$ = _this.store.select(fromStore.getUserInfo);
        _this.passengers$ = _this.store.select(fromStore.getMiniIBEPassengers);
        _this.currency = _this.currencyService.INDRA_getCurrencySymbol().unit;
        _this.isMobile$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.isMobile = value;
        });
        _this.resize$ = fromEvent(window, 'resize')
            .pipe(debounceTime(250), map(function () { return window.innerWidth; }), distinctUntilChanged(), startWith(window.innerWidth), tap(function (width) { return _this.screen.setWindowWidth(Number(width)); }));
        _this.priceUnit$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.priceUnit = value;
        });
        _this.booking_trip$.subscribe(function (value) {
            _this.bookingTrip = value;
        });
        _this.dailyCosts$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (costs) {
            if (costs) {
                _this.dailyCosts = costs;
            }
        });
        _this.bookingSteps$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (steps) {
            if (steps) {
                _this.bookingSteps = steps;
            }
        });
        _this.currentStep$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.currentStep = value;
        });
        _this.userInfo$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (user) {
            _this.isLoggedIn = user ? true : false;
        });
        _this.calendarPriceService.monthlyLowestPrice$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (response) {
            _this.months = response;
            _this.cdr.markForCheck();
        });
        _this.passengers$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.paxType = _this.passengerTypeService.getPassengerCodeByCount(value);
        });
        _this.buildMonthlist();
        return _this;
    }
    Object.defineProperty(INDRASelectMonthModalComponent.prototype, "month", {
        set: function (data) {
            this._months = Object.assign({}, data);
        },
        enumerable: true,
        configurable: true
    });
    INDRASelectMonthModalComponent.prototype.INDRA_printMinPrice = function (valueDisplay) {
        if (valueDisplay) {
            if (this.priceUnit === 'miles') {
                return this.INDRA_getTranslationKey('dates.text.from') + this.currencyService.INDRA_formatMiles(valueDisplay) + ' M';
            }
            else if (this.priceUnit === 'cash') {
                return this.INDRA_getTranslationKey('dates.text.from') + this.currencyService.INDRA_formatCash(valueDisplay) + ' ' + this.currency;
            }
        }
        return '';
    };
    INDRASelectMonthModalComponent.prototype.INDRA_monthHasMinPrice = function (valueDisplay) {
        return (valueDisplay ? true : false);
    };
    INDRASelectMonthModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.isLoading = value;
        });
        this.resize$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe();
    };
    INDRASelectMonthModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRASelectMonthModalComponent.prototype.closeModal = function () {
        this.modalService.close();
    };
    INDRASelectMonthModalComponent.prototype.INDRA_handleSelectMonthClick = function (month) {
        if (this.data && this.data[0] && this.data[0].handleClose) {
            this.data[0].handleClose(false, month);
            this.modalService.close();
        }
        else {
            this.modalService.close();
        }
    };
    INDRASelectMonthModalComponent.prototype.buildMonthlist = function () {
        var routeType = this.INDRA_identifyRouteType(this.bookingSteps);
        if (this.currentStep == 0 && this.bookingSteps.length > 0 && !this.bookingSteps[this.currentStep].date_selected) {
            this.calendarPriceService.getMonthPrice(this.bookingSteps, routeType, 0, this.isLoggedIn, this.priceUnit, this.paxType);
        }
        else if (this.bookingSteps[1] && !this.bookingSteps[1].date_selected) {
            this.calendarPriceService.getMonthPrice(this.bookingSteps, routeType, 1, this.isLoggedIn, this.priceUnit, this.paxType);
        }
        else {
            this.months = this.calendarPriceService.buildMonthlist(); // set months with only labels (no prices)
        }
    };
    INDRASelectMonthModalComponent.prototype.INDRA_identifyRouteType = function (steps) {
        var tripType = TRIP_TYPE_ROUND_TRIP_CODE;
        if (steps.length == 1) {
            tripType = TRIP_TYPE_ONE_WAY_CODE;
        }
        return tripType;
    };
    INDRASelectMonthModalComponent.prototype.INDRA_getMonthYear = function (date) {
        var month = moment(date).format('MMMM').toLowerCase();
        var year = moment(date).format('YYYY').toLowerCase();
        month = this.INDRA_getTranslationKey('dates.text.' + month);
        return month + ' ' + year;
    };
    INDRASelectMonthModalComponent.prototype.INDRA_getTranslationKey = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    return INDRASelectMonthModalComponent;
}(AbstractModalContentComponent));
export { INDRASelectMonthModalComponent };
